export default "__VITE_ASSET__HAGlCnfC__"